import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import { useFormik } from 'formik';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { fileGroupOptions, logTypeOptions } from '../../../utils/mics';
import { useDispatch, useSelector } from 'react-redux';
import appActions from '../../../appActions';
import { useLocation } from 'react-router';

const IntFileLogFilterForm = (props) => {

    const dispatch = useDispatch();
    const filters = useSelector((state) => state.intFileLog.filters);
        
    const { state } = useLocation();

    const { handleSearch, handleReset, onFormValuesChange } = props;

    const formik = useFormik({
        initialValues: {
            fileId: ( state?.filterByFileId  || filters?.fileId ) || '',
            storeId: filters?.storeId || '',
            logGroup: filters?.logGroup || null,
            logType: filters?.logType || "ERROR",
            date_from: filters?.date_from || moment().subtract(30, 'days').toDate(),
            date_till: filters?.date_till || new Date(),
        },
        onSubmit: (values) => {
            const data = {
                ...values,
                date_from: values.date_from ? moment(values.date_from).format('YYYY-MM-DD') : '',
                date_till: values.date_till ? moment(values.date_till).format('YYYY-MM-DD') : '',
            };
            dispatch(appActions.INTFILELOG_SET_FILTERS_REQUEST(values));
            handleSearch(data);
        },
    });

   const handleClear = () => {
        // Reset filters in Redux store
        dispatch(appActions.INTFILELOG_SET_FILTERS_REQUEST({}));

        // Explicitly reset fileId and other form values
        formik.resetForm({
            values: {
                fileId: '',  // Reset fileId to empty
                storeId: '',
                logGroup: null,
                logType: null,
                date_from: '',
                date_till: '',
            },
        });
          
        onFormValuesChange(null);
        handleReset();
    };

    const handleChange = (e) => {
        formik.handleChange(e);
        if (onFormValuesChange) {
            const updatedValues = { ...formik.values, [e.target.name]: e.target.value };
             const data = {
                ...updatedValues,
                date_from: updatedValues.date_from ? moment(updatedValues.date_from).format('YYYY-MM-DD') : '',
                date_till: updatedValues.date_till ? moment(updatedValues.date_till).format('YYYY-MM-DD') : '',
            };
            onFormValuesChange(data);
        }
    };

    const isDateTillUpdated = useRef(false); // Track if update is needed

    useEffect(() => {
        if (
            formik.values.date_from &&
            (!formik.values.date_till || new Date(formik.values.date_till) < new Date(formik.values.date_from))
        ) {
            if (!isDateTillUpdated.current) { // Prevent infinite loop
                formik.setFieldValue("date_till", formik.values.date_from);
                isDateTillUpdated.current = true; // Mark as updated
            }
        } else {
            isDateTillUpdated.current = false; // Reset when update is not needed
        }
    }, [formik, formik.values.date_from]); // Only trigger when date_from changes

    const renderFormArea = () => {
        return (
            <>
                <div className="p-fluid formgrid grid w-full">
                    <div className="field col-12 md:col-3">
                        <label htmlFor="fileId">File ID</label>
                        <InputText id="fileId" name="fileId" type="text" value={formik.values.fileId} onChange={handleChange} />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="fileId">Store ID</label>
                        <InputText id="storeId" name="storeId" type="text" value={formik.values.storeId} onChange={handleChange}/>
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="logGroup">Log Group</label>
                        <Dropdown filter showClear  value={formik.values.logGroup}  onChange={handleChange} options={fileGroupOptions} id="logGroup"  name="logGroup"  optionLabel="name" optionValue="name" />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="title">Log Type</label>
                        <Dropdown filter showClear value={formik.values.logType}  onChange={handleChange} options={logTypeOptions} id="logType"  name="logType"  optionLabel="code" optionValue="name" />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="logText">Log Text</label>
                        <InputText id="logText" name="logText" type="text" value={formik.values.logText} onChange={handleChange}/>
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="date_from">Date From</label>
                        <Calendar id="date_from" name="date_from"  value={formik.values.date_from} onChange={handleChange} dateFormat="dd-mm-yy" showIcon maxDate={new Date()}/>
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="date_from">Date Till</label>
                        <Calendar id="date_till" name="date_till" value={formik.values.date_till} onChange={handleChange} dateFormat="dd-mm-yy" showIcon minDate={formik.values.date_from}/>
                    </div>
                </div>
                <div className="grid px-2 py-4 flex-row-reverse gap-10">
                    <Button type="submit" icon="pi pi-search" label="Search" severity="success" outlined className="p-button-success mr-2 tp" data-pr-tooltip="Search"/>
                    <Button type="button" icon="pi pi-filter-slash" className='tp' data-pr-tooltip="Reset Filter" label="Reset Filter" severity="secondary" outlined onClick={handleClear} />
                </div>
            </>
        );
    };

    return <form onSubmit={formik.handleSubmit}>{renderFormArea()}</form>;
};

export default IntFileLogFilterForm;
